import React, { useEffect, useState } from "react";
import avatar from "../../assets/img/header-bar/avatar.png";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PopUp from "@components/PopUp";
import { RootState, clearStateAndPersist } from "@store/store";
import { Link } from "react-router-dom";
import Img from "@assets/img";
import { jwtDecode } from "jwt-decode";
import * as S from "./style";
import { API_END_POINTS } from "@utils/EndPoint";
import { routes } from "@const/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import img from "@assets/img";
import { Inbox } from "@novu/react";
import AppearanceInbox from "./inbox.style";
import useComponentVisible from "src/hooks/useComponentVisible";
import * as Z from "../../components/PopUp/style";
import { ThemeLogoFromCssVar, useIsDaburTheme } from "./imageTheme";
import useThemeInitializer from "src/ThemeInitializer";
import { Button, NavItemLink, NavWrapper, StyledCollapse } from "@components/Navigate";
import HowItWorks from "@components/HowItWorks";
import { useDispatch } from "react-redux";
import { EAppAction } from "@store/appReducer";
import { NavLink } from "react-router-dom";

interface Props {
  backToDashboard?: boolean;
  isBack?: boolean;
  backlabel?: string;
  title?: string;
  isLoginPage?: boolean;
}

const applicationIdentifier =
  process.env.REACT_APP_NOVU_APPLICATION_IDENTIFIER || "";

const HeaderBar = ({
  isBack = false,
  backToDashboard = false,
  title,
  backlabel,
}: Props) => {
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [subscriberId, setSubscriberId] = useState("");
  const [subscriberIdHash, setSubscriberIdHash] = useState("");
  const { user } = useSelector((state: RootState) => state.auth);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const [isLoginPage, setIsLoginPage] = useState<boolean>(false);
  const { isDabur } = useThemeInitializer();
  const isLoggedIn = useSelector((state: RootState) => state.auth.token);
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const decodedToken = () => {
    if (isLoggedIn) {
      const decoded: any = jwtDecode(isLoggedIn);
      setSubscriberId(decoded.subId);
      setSubscriberIdHash(decoded.subIdHash);
    }
  };
  const navigate = useNavigate();

  const handleDropdown = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const logout = () => {
    setVisiblePopup(false);
    clearStateAndPersist();
    navigate("/");
  };

  const onBack = () => {
    if (isBack) return navigate(-1);
    navigate(routes.dashboard);
  };
  useEffect(() => {
    decodedToken();
  }, [isLoggedIn]);

  useEffect(() => {
    if (location.pathname === API_END_POINTS.LOGIN || location.pathname === API_END_POINTS.HOMEPAGE) {
      setIsLoginPage(true);
    }
  }, []);


  const toggleModal = () => setModalOpen((prev) => !prev);

  const handleEarnGameTickets = () => {
    if (!user) {
      navigate(isDabur ? "/login" : "/");
      return;
    }

    dispatch({
      type: EAppAction.SHOW_REFER_POPUP,
      payload: true,
    });
  };

  return (
    <S.ContainerClass style={{ backgroundColor: isLoggedIn ? "#EAF0D5" : "white" }}>
      <S.Wrapper >
        <S.Row>
          <ThemeLogoFromCssVar
            alt="logo"
            style={{ width: "var(--header-logo-size)" }}
            header={true}
          />
          {/* {(location.pathname === "/" || location.pathname === "/login" || location.pathname === "/preview") && (

            <NavWrapper>
              <NavItemLink
                to={routes.dashboard}
                tag={Link}
                className="navbar-item"
                style={{ color: "black" }}
              >
                Games Lobby
              </NavItemLink>
              <NavItemLink
                // href="#"
                className="navbar-item cursor-pointer "
                onClick={toggleModal}
                style={{ color: "black" }}
              >
                How it Works
              </NavItemLink>
              <NavItemLink
                // href="#"
                className="navbar-item cursor-pointer "
                onClick={handleEarnGameTickets}
                style={{ color: "black" }}
              >
                Earn Game Tickets
              </NavItemLink>
            </NavWrapper>
          )} */}

        </S.Row>
        {/* <S.Row>
          {(isBack || backToDashboard) && (
            <S.BackButton onClick={onBack}>
              <div>
                <img src={Img.BackButton} />
                <span>{backlabel}</span>
              </div>
            </S.BackButton>
          )}
          <S.Title>{title}</S.Title>
        </S.Row> */}
        {/* {useIsDaburTheme() && (
          <div className="input-group w-50">
            <input type="text" className="form-control" placeholder="Search Games" />
            <span className="input-group-text"><FontAwesomeIcon icon={["fas", "search"]} /></span>
          </div>
        )} */}

        {/* <Button
          hidden={!!user || !!isLoggedIn || isLoginPage || location.pathname === "/preview"}
          type="button"
          onClick={() => navigate(API_END_POINTS.LOGIN)}
          className="btn-round mr-1 btn btn-primary mb-hide"
        >
          Login <FontAwesomeIcon icon={["fas", "sign-in"]} />
        </Button> */}

        <NavLink
          to={"https://www.daburshop.com"}
          // tag={Link}
          className="text-[#4B975B] font-bold text-sm md:text-base mx-4 hover:underline hover:text-[#4B975B] text-nowrap"
        >
          Go to daburshop
        </NavLink>

        {user && (
          <S.UserContainer>
            {subscriberId && subscriberIdHash && (
              <Inbox
                applicationIdentifier={applicationIdentifier}
                subscriberId={subscriberId}
                subscriberHash={subscriberIdHash}
                appearance={AppearanceInbox.appearanceInbox}
              />
            )}
            {/* <FontAwesomeIcon 
              className="heart-icon" 
              icon={faHeartRegular} 
              onClick={() => navigate("/favorite-raffle")}
              style={{ cursor: "pointer" }}
            /> */}
            <S.Dropdown>
              <S.DropdownTop onClick={handleDropdown}>
                <FontAwesomeIcon icon={["fas", "user"]} />
                {/* <h4>{user?.username ? user?.username : user?.phoneNumber}</h4> */}
                {/* <img src={Img.ChevronDown} /> */}
              </S.DropdownTop>
              <div ref={ref}>
                {isComponentVisible && (
                  <S.DropdownBottom>
                    <Link to={API_END_POINTS.PROFILE}>
                      <S.DropdownOption>
                        <img src={img.userLogo} />
                        <span>Profile</span>
                      </S.DropdownOption>
                    </Link>
                    {/* <Link to={API_END_POINTS.TICKETS}>
                      <S.DropdownOption>
                        <img src={img.walletLogo} />
                        <span>My Ticket</span>
                      </S.DropdownOption>
                    </Link>
                    <Link to={API_END_POINTS.FAVORITE_RAFFLE}>
                      <S.DropdownOption>
                        <img src={img.heartLogo} />
                        <span style={{ textWrap: "nowrap" }}>
                          Favorite Raffle
                        </span>
                      </S.DropdownOption>
                    </Link> */}
                    <div style={{ marginLeft: 5 }}>
                      <S.DropdownOption onClick={() => setVisiblePopup(true)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M9.66667 10.3333L13 7M13 7L9.66667 3.66667M13 7H5M7 10.3333C7 10.9533 7 11.2633 6.93185 11.5176C6.74692 12.2078 6.20782 12.7469 5.51764 12.9319C5.26331 13 4.95332 13 4.33333 13H4C3.06812 13 2.60218 13 2.23463 12.8478C1.74458 12.6448 1.35523 12.2554 1.15224 11.7654C1 11.3978 1 10.9319 1 10V4C1 3.06812 1 2.60218 1.15224 2.23463C1.35523 1.74458 1.74458 1.35523 2.23463 1.15224C2.60218 1 3.06812 1 4 1H4.33333C4.95332 1 5.26331 1 5.51764 1.06815C6.20782 1.25308 6.74692 1.79218 6.93185 2.48236C7 2.7367 7 3.04669 7 3.66667"
                            stroke="#F47C9A"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="signout">Sign out</span>
                      </S.DropdownOption>
                    </div>
                  </S.DropdownBottom>
                )}
              </div>
            </S.Dropdown>

            {/* <FontAwesomeIcon icon={['fas', 'user']} color=" var(--disabled-button-label-color)"/> */}
          </S.UserContainer>
        )}
      </S.Wrapper>

      <PopUp
        visible={visiblePopup}
        title=""
        footer={false}
        onOk={() => {
          setVisiblePopup(false);
          logout();
        }}
        onCancel={() => setVisiblePopup(false)}
        okText="No"
        cancelText="Yes"
      >
        <div className="relative w-full max-w-lg mx-auto overflow-hidden" onClick={() => setVisiblePopup(false)}>
          {/* Green gradient background card */}
          <div className="relative bg-gradient-to-br from-[#4B975B] via-[#5dad6d] to-[#4B975B] rounded-3xl p-8 md:p-10"
            onClick={(e) => e.stopPropagation()}>
            {/* Decorative background pattern */}
            <div className="absolute inset-0 opacity-10 pointer-events-none">
              <div className="absolute top-0 left-0 w-48 h-48 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
              <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2 opacity-50"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 space-y-6">
              {/* Icon with glow effect */}
              <div className="flex justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-white/30 rounded-full blur-xl"></div>
                  <div className="relative w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border-2 border-white/30 shadow-xl">
                    <svg
                      className="w-10 h-10 text-white drop-shadow-lg"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2.5}
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Title */}
              <div className="text-center space-y-2">
                <h2 className="text-3xl md:text-4xl font-extrabold text-white drop-shadow-md">
                  Confirm Logout
                </h2>
                <p className="text-base md:text-lg text-white/95 leading-relaxed max-w-md mx-auto">
                  You're about to end your session. Are you sure you want to log out?
                </p>
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row justify-center items-stretch gap-4 pt-2">
                <button
                  onClick={() => {
                    setVisiblePopup(false);
                  }}
                  className="group relative px-8 py-4 bg-white text-[#4B975B] rounded-xl font-bold text-base md:text-lg shadow-xl hover:shadow-2xl hover:scale-105 active:scale-100 transition-all duration-300 min-w-[160px] overflow-hidden"
                >
                  <span className="relative z-10">Cancel</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-white to-gray-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </button>
                <button
                  onClick={() => {
                    setVisiblePopup(false);
                    logout();
                  }}
                  className="group relative px-8 py-4 bg-white/20 backdrop-blur-md border-2 border-white/50 text-white rounded-xl font-bold text-base md:text-lg shadow-xl hover:bg-white/30 hover:border-white hover:shadow-2xl hover:scale-105 active:scale-100 transition-all duration-300 min-w-[160px]"
                >
                  <span className="relative z-10">Yes, Log Out</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </PopUp>
      <HowItWorks
        isOpen={modalOpen}
        toggle={toggleModal}
        videoUrl="https://youtu.be/V2pl_zeos70"
      />
    </S.ContainerClass>
  );
};

export default HeaderBar;
